const ONE_WEEK_IN_MILLISECONDS = 7 * 24 * 60 * 60 * 1000;
const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
const ABBREVIATED_DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function meridianTimeText({ hours, minutes }) {
  const meridianTime = hours >= 12 ? 'pm' : 'am';
  const hour = hours % 12 ? hours % 12 : 12;
  const formatMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${hour}:${formatMinutes} ${meridianTime}`;
}

function formatInMeridianTime(date = '') {
  const _date = new Date(date);
  const hours = _date.getHours();
  const minutes = _date.getMinutes();
  return meridianTimeText({ hours, minutes });
}

function getStringHour(hour = 0) {
  let _hour = hour;
  if (hour > 12) {
    const _difference = hour - 12;
    _hour = _difference;
  }
  return hour >= 10 ? `${hour}` : `0${hour}`;
}

/**
 * formatToConventionalSystem
 * @description function that receive a hour and return the time in strian and the meridian format time (AM/PM)
 * @param {String} time : Hour in format string example: '13:00:00';
 * @returns {Object} { timeString: '04:30', timeFormat: 'AM' | 'PM' }
 */
function formatToConventionalSystem(time) {
  const splitTime = time.split(':');
  let hour = parseInt(splitTime[0]);
  const minutes = splitTime[1];

  if (hour >= 24) {
    hour %= 24;
  }

  const meridianFormat = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  const timeString = `${getStringHour(hour)}:${minutes}`;

  return { timeString, timeFormat: meridianFormat };
}

function formatLongDate(date) {
  var dayOptions = { year: 'numeric', month: 'long', day: 'numeric' };

  const _date = date ? date.replace(/-/g, '/') : '';

  const textDate = new Date(_date).toLocaleDateString('en-US', dayOptions);

  return textDate;
}

function startOfWeek(selectDay) {
  const weekday = selectDay.getDay();
  return new Date(selectDay.getTime() - Math.abs(weekday) * ONE_DAY_IN_MILLISECONDS);
}

function calculateWeeksPriorToTheCurrentDay(selectedDate) {
  const currentDate = new Date();
  const previousWeeks = Math.ceil(
    (startOfWeek(currentDate) - startOfWeek(new Date(selectedDate))) / ONE_WEEK_IN_MILLISECONDS,
  );
  return Math.abs(previousWeeks);
}

function firstAndLastDateOfAWeek(selectedDate) {
  const _startOfWeek = new Date(selectedDate);
  _startOfWeek.setDate(_startOfWeek.getDate() - _startOfWeek.getDay());

  const _endOfWeek = new Date(selectedDate);
  _endOfWeek.setDate(_endOfWeek.getDate() + (6 - _endOfWeek.getDay()));

  const startOfWeek = new Date(_startOfWeek).toISOString().slice(0, 10);
  const endOfWeek = new Date(_endOfWeek).toISOString().slice(0, 10);
  return { startOfWeek, endOfWeek };
}

function formatLongDateTime(date) {
  const dayOptions = {
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    month: 'short',
    year: 'numeric',
    day: 'numeric',
  };
  const textDate = new Date(date).toLocaleDateString('en-US', dayOptions);
  return textDate;
}

function formatDateTask(date) {
  const dayOptions = { month: 'short', day: 'numeric' };
  const _date = date.includes('T') ? new Date(date) : new Date(date.replace(/-/g, '/'));
  const textDate = _date.toLocaleDateString('en-US', dayOptions);
  return textDate;
}

function formatNumericDateCalendar(date) {
  const dayOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const _date = date
    ? date.includes('T')
      ? new Date(date)
      : new Date(date.replace(/-/g, '/'))
    : new Date();
  const textDate = _date.toLocaleDateString('en-CA', dayOptions);
  return textDate;
}

function formatHourSelected(date) {
  const textDate = date ? new Date(date) : new Date();
  const hour = textDate.getHours() < 10 ? `0${textDate.getHours()}` : textDate.getHours();
  const minutes = textDate.getMinutes() < 10 ? `0${textDate.getMinutes()}` : textDate.getMinutes();
  const hourToDate = `${hour}:${minutes}`;
  return hourToDate;
}

function formatNameDay(date) {
  const dayOptions = { weekday: 'short', month: 'short', day: 'numeric' };
  const textDate = new Date(date).toLocaleDateString('en-US', dayOptions);
  return textDate;
}

function formatDateAndWeekday(date) {
  const dayOptions = {
    weekday: 'short',
    month: 'short',
    year: 'numeric',
    day: 'numeric',
    timeZone: 'UTC',
  };
  const textDate = new Date(date).toLocaleDateString('en-US', dayOptions);
  return textDate;
}

function formatDateToLocalISOString(date) {
  const newDate = date ? new Date(date) : new Date();
  const year = newDate.getFullYear();
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const hours = newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours();
  const minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes();
  const seconds = newDate.getSeconds() < 10 ? '0' + newDate.getSeconds() : newDate.getSeconds();

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

function getNumericDate(date) {
  const now = date ? new Date(date) : new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return `${year}-${month}-${day}`;
}
/**
 * Calculates the next time that is a multiple of 15 minutes (or a specified number of minutes in the future).
 *
 * @function
 * @name AdvanceTheTimeByXMinutes
 *
 * @param {number} [jumpInMinutes=0] - An optional parameter that specifies the number of additional minutes to jump into the future beyond the next 15-minute interval (default: 0).
 *
 * @returns {Date} Returns a `Date` object representing the next time that is a multiple of 15 minutes (or `jumpInMinutes` plus 15) in the future.
 *
 * @example
 *
 * const next15 = AdvanceTheTimeByXMinutes();
 * console.log(next15); // Example output: "Mon Mar 28 2022 14:30:00 GMT-0400 (Eastern Daylight Time)"
 *
 * const next45 = AdvanceTheTimeByXMinutes(30);
 * console.log(next45); // Example output: "Mon Mar 28 2022 15:45:00 GMT-0400 (Eastern Daylight Time)"
 */
function AdvanceTheTimeByXMinutes(jumpInMinutes = 0) {
  const defaultJump = 15;
  const now = new Date();
  const minutes = now.getMinutes();
  const jumpMinutes = jumpInMinutes + defaultJump - (minutes % defaultJump);
  const futureTime = now.setMinutes(minutes + jumpMinutes);
  return futureTime;
}

/**
  Add the hours, minutes and seconds of the endDate to the initDate, in order to keep the duration of the event in the same day, since the initial date changes when dragging and dropping in the calendar and you don't want long events.
  If endDate is not provided, adds 1 hour to initDate.
  @param {Date} initDate - The initial date modified by drag and drop, the hours, minutes and seconds of endDate will be added.
  @param {Date} [endDate] - The date from which the hours, minutes, and seconds will be extracted and added to initDate.
  @returns {Date} finalDate - The end date formed by the day of the initial date and the hours of the original end date in custom local ISO format.
    */
function getStartDateWhitHoursOfEndDate(initDate, endDate) {
  if (!endDate) {
    initDate.setHours(initDate.getHours() + 1);
    return initDate;
  }

  const finalDate = new Date(initDate);
  const _endDate = new Date(endDate);

  const hoursEndDate = _endDate.getHours();
  const minutesEndDate = _endDate.getMinutes();
  const secondsEndDate = _endDate.getSeconds();

  finalDate.setHours(hoursEndDate);
  finalDate.setMinutes(minutesEndDate);
  finalDate.setSeconds(secondsEndDate);

  return finalDate;
}

function datePriorToTheCurrentDate(date, hour) {
  const selectedDateTime = new Date(`${date} ${hour}`);
  const currentDateTime = new Date();

  return selectedDateTime < currentDateTime;
}

function dateFormatAbbreviatedNameOfDayAndNumberedDay(date) {
  const dateCopy = new Date(date);
  const dayOfWeek = ABBREVIATED_DAY_NAMES[dateCopy.getDay()];
  const dayOfMonth = dateCopy.getDate();

  return `${dayOfWeek} ${dayOfMonth}`;
}

function formatAMPMHour(strHour) {
  const splitText = strHour.split(':');
  const hours = parseInt(splitText[0]);
  const minutes = parseInt(splitText[1]);

  return meridianTimeText({ hours, minutes });
}

export {
  formatInMeridianTime,
  formatToConventionalSystem,
  formatLongDate,
  calculateWeeksPriorToTheCurrentDay,
  firstAndLastDateOfAWeek,
  formatLongDateTime,
  formatDateTask,
  formatNumericDateCalendar,
  formatHourSelected,
  formatNameDay,
  formatDateAndWeekday,
  formatDateToLocalISOString,
  getNumericDate,
  AdvanceTheTimeByXMinutes,
  getStartDateWhitHoursOfEndDate,
  datePriorToTheCurrentDate,
  dateFormatAbbreviatedNameOfDayAndNumberedDay,
  formatAMPMHour,
};
